export const getElement = (selector, { context = document } = {}) =>
  context.querySelector(selector)
export const getElements = (
  selector,
  { context = document, asArray = true } = {}
) => {
  const items = context.querySelectorAll(selector)

  return asArray ? Array.from(items) : items
}

export const doesStringContainAny = (str, items = []) =>
  items.some(i => str.includes(i))

export const createElement = (tag, options = {}) => {
  const el = document.createElement(tag)
  Object.values(options).forEach(([key, value]) => {
    el.setAttribute(key, value)
  })

  return el
}

export const serializerQueryParams = params =>
  Object.entries(params)
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&')

export const styleToNumber = str => parseInt(str, 10)

export const slideToggle = el => {
  event.preventDefault()
  if (!el.classList.contains('slideToggle-active')) {
    el.classList.add('slideToggle-active')
    el.style.height = 'auto'

    const height = `${el.clientHeight}px`

    el.style.height = '0px'

    setTimeout(function () {
      el.style.height = height
    }, 0)
  } else {
    el.style.height = '0px'
    el.addEventListener(
      'transitionend',
      function () {
        el.classList.remove('slideToggle-active')
      },
      {
        once: true
      }
    )
  }
}

export const getOffsetTop = (el, parent = document.body) => {
  let offsetTop = 0
  do {
    if (el && el.offsetTop !== null) {
      offsetTop += el.offsetTop
    }

    if (el) {
      el = el.offsetParent
    }
  } while (el && (el !== parent || el !== document.body))

  return offsetTop
}

export const getOffsetLeft = (el, parent = document.body) => {
  let offsetLeft = 0
  do {
    if (el && el.offsetTop !== null) {
      offsetLeft += el.offsetLeft
    }

    if (el) {
      el = el.offsetParent
    }
  } while (el && (el !== parent || el !== document.body))

  return offsetLeft
}
